module.exports = __webpack_public_path__ + "54a1646d3603cd422f46848ab2b517e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/personal-workouts-gradient.png
// module id = 1873
// module chunks = 1